import { useBreakpoint } from '../../styles/breakpoints';
import styled from "styled-components";

export const Flexbox = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;

export const FlexboxIcon = styled(Flexbox)`
  & > * {
    &:first-child {
      flex: 1;
    }
    &:last-child {
      margin-left: .5rem;
    }
  }
`;

export const FlexboxVertical = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
`;

export const FlexboxCenter = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

export const FlexContainer = styled.div`
	flex: 1 0 0%;
	min-width: 0;
`;

export const CenterForm = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;	
	margin: auto;
`;

export const BoxedContainer = styled.div`
	max-width: 1440px;
	width:100%;
	margin:0 auto;
	padding: 1rem 2rem;
`;

export const ListULContainer = styled.div`
  ul {
    list-style: none;
    
    li {
      &:not(:last-child) {
        margin-bottom: .5rem;
      }
    }
    
    ul {
      margin-left: .75rem;
      margin-bottom: .75rem;
    }
  }
`;
